"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleContainer = exports.getContainer = void 0;
var _ykbUtils = require("ykb-utils");
var getContainer = exports.getContainer = function getContainer() {
  var container = (0, _ykbUtils.containerChecker)();
  var isBodyContainer = isBody(container);
  if (isBodyContainer) {
    return;
  }
  return container;
};
var isBody = function isBody(container) {
  if (window.HTMLBodyElement) {
    return container instanceof HTMLBodyElement;
  }
};
var handleContainerName = function handleContainerName(container) {
  var hasContainerName = container.style.containerName && RegExp(/\bykbUiGrid\b/g).test(container.style.containerName);
  if (hasContainerName) {
    return;
  }
  container.style.containerName += ' ykbUiGrid';
};
var handleContainer = exports.handleContainer = function handleContainer() {
  var container = getContainer();
  if (!container) {
    console.warn("ykb-ui Grid: container should be used in sparx process");
    return;
  }
  container.style.containerType = 'inline-size';
  handleContainerName(container);
  return container;
};